module.exports = __webpack_public_path__ + "img/loading_06.98f15fa6.svg";